import { RouteType } from "../../../types/RouteType";
import RootStore from "../../../stores/RootStore";
import JobPanelManagementStore from "./JobPanelManagement.Store";

const jobPanelManagementRoute: RouteType = {
    name: "Job Panel Management",
    path: "/crm/job-panel-management/:jobId?",
    defaultParams: {
        jobId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./JobPanelManagement.Header"),
            title: "Job Panel Management",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./JobPanelManagement.Container"),
            grayBackground: false,
        },
    },
    group: 'CRM',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const jobPanelStore = rootStore.jobPanelManagementStore as JobPanelManagementStore;
            if (jobPanelStore) {
                if (params.jobId && typeof params.jobId === 'string') {
                    await jobPanelStore.loadJobPanels(params.jobId);
                } else {
                    await jobPanelStore.loadAllJobs();
                }
            }
            return true;
        } catch (error) {
            console.error("Failed to load job panel data:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.jobId !== previousParams?.jobId) {
            const jobPanelStore = rootStore.jobPanelManagementStore as JobPanelManagementStore;
            if (jobPanelStore) {
                if (params.jobId && typeof params.jobId === 'string') {
                    await jobPanelStore.loadJobPanels(params.jobId);
                } else {
                    await jobPanelStore.loadAllJobs();
                }
            }
        }
    },
    dialogs: [
        {
            name: "panelDesignDialog",
            component: () => import("./PanelDesignDialog"),
            title: "Panel Design Assignment",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                // Dialog components manage their own form state
                // The actual save logic would be implemented here
                console.log("Panel design dialog submitted");
                return true;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                // For now, always return true as validation is handled in the dialog
                return true;
            },
            cancelButton: true,
            height: 600,
        },
        {
            name: "panelStatusDialog",
            component: () => import("./PanelStatusDialog"),
            title: "Update Panel Status",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                // Dialog components manage their own form state
                // The actual save logic would be implemented here
                console.log("Panel status dialog submitted");
                return true;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                // For now, always return true as validation is handled in the dialog
                return true;
            },
            cancelButton: true,
        },
    ],
};

export default jobPanelManagementRoute;
